export enum PriorityCode {
  Critical = 'critical',
  High = 'high',
  Medium = 'medium',
  Low = 'low',
  StandardRequest = 'standard_request',
}
